module.exports = __webpack_public_path__ + "img/layout_04_default.41f41e87.svg";